@if (taskForm) {
  <bic-popup (close)="close()" [hasBackdrop]="true"
             [title]="!task.id ? 'Task erstellen' : (permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT') ? 'Task bearbeiten' : 'Task ansehen')"
             customClass="w-[944px] max-w-[95vw] max-h-[90vh]">
    <div bicPopupContent class="flex flex-col gap-4 overflow-y-auto max-h-[calc(90vh-180px)]">

      <div class="relative">
        <form [formGroup]="taskForm" class="h-full">
        <div class="flex flex-col justify-center items-start gap-4">
          <div class="flex flex-row w-full">
            <div class="w-full">
              <bic-input [label]="'Name'" [placeholder]="'Task Name eingeben*'" [required]="true"
                         [showX]="false" [maxLength]="taskTitleMaxLength" class="w-full border-0 p-0" formControlName="title" type="text"
                         [errorCondition]="!!taskForm.get('title')?.touched && !!taskForm.get('title')?.hasError('blank')"></bic-input>
              @if (taskForm.get('title')?.touched && taskForm.get('title')?.hasError('blank')) {
                <span class="text-sm text-red">Bitte einen Namen eingeben (nicht nur Leerzeichen).</span>
              }
            </div>
          </div>
          <div class="flex flex-row w-full gap-6">
            <bic-select class="w-1/3" formControlName="priority" label="Priorität"
                        placeholder="Priorität auswählen">

              <span #iconStart iconStart>
                <fa-icon [icon]="faCircleSmall" [ngClass]="{
          'text-red': taskForm.get('priority')?.value === 'HIGH',
          'text-gray-500': taskForm.get('priority')?.value === 'NORMAL',
          'text-green': taskForm.get('priority')?.value === 'LOW'
          }" class="text-[1.6rem]"></fa-icon>
              </span>
              @for (priority of priorityEnum | keyvalue: reverse; track priority) {
                <bic-dropdown-element
                  [value]="priority.value">
                  <fa-icon [icon]="faCircleSmall" [ngClass]="{
          'text-red': priority.value === 'HIGH',
          'text-gray-500': priority.value === 'NORMAL',
          'text-green': priority.value === 'LOW'
          }" class="text-[1.6rem] flex items-center"></fa-icon>
                  {{ priority.value | priority }}
                </bic-dropdown-element>
              }
            </bic-select>
            <bic-select class="w-1/3" formControlName="state"
                        label="Status"
                        placeholder="Status auswählen">
              <span #iconStart iconStart>
                <fa-icon [icon]="getStatusIcon(taskForm.get('state')!.value)" class="text-base text-gray"></fa-icon>
              </span>
              @for (state of stateEnum | keyvalue: keepOrder; track state) {
                @if ((state.value == stateEnum.VERIFIED)) {
                  <bic-dropdown-element
                    [disabled]="user?.id != taskForm.value['creationUser']?.id" [value]="state.value">
                    <fa-icon [icon]="faCircleCheck" class="text-base"></fa-icon>
                    {{ state.value | taskState }}
                  </bic-dropdown-element>
                }
                @if ((state.value != stateEnum.VERIFIED)) {
                  <bic-dropdown-element
                    [value]="state.value">
                    <fa-icon [icon]="getStatusIcon(state.value)" class="text-base"></fa-icon>
                    {{ state.value | taskState }}
                  </bic-dropdown-element>
                }
              }
            </bic-select>
            <bic-select class="w-1/3" formControlName="lph" label="Leistungsphase"
                        placeholder="Leistungsphase auswählen">
              @for (lph of LphEnum | keyvalue; track lph) {
                <bic-dropdown-element
                  [value]="lph.value"> Leistungsphase {{ lph.value | lph }}
                </bic-dropdown-element>
              }
            </bic-select>
          </div>
          <div class="flex flex-row w-full">
            <div class="w-full">
              <bic-textarea
                [label]="'Beschreibung'"
                formControlName="description"
                id="task_description"
                placeholder="Hier eine Beschreibung eingeben oder Notizen hinzufügen"></bic-textarea>
            </div>
          </div>
          <div class="flex flex-row w-full gap-8">
            <div class="w-1/3">
              <bic-input (dateChange)="taskForm.get('dueDate')?.setValue($event)"
                         [iconStart]="faCalendarDays" [icon]="faChevronDown" [isDatepicker]="true" [label]="'Fälligkeitsdatum'"
                         [placeholder]="'Datum auswählen'" [showX]="false"
                         bicDatepickerInput class="w-full"
                         formControlName="dueDate"></bic-input>
            </div>
            <div class="w-1/3">
              <bic-select #testen [comparator]="compare" [dropdownWithSelectionWidth]="true"
                          [onlyShowPlaceholder]="true" [placeholder]="'Person auswählen'" class="w-full"
                          formControlName="assignedToUser" label="Verantwortlich">
                <span #iconStart iconStart>
                  <fa-icon [icon]="faUserPlus" class="text-base text-gray-300"></fa-icon>
                </span>
                @for (user of users; track user) {
                  <bic-dropdown-element [value]="user"> {{ user.firstName }} {{ user.lastName }}
                  </bic-dropdown-element>
                }
              </bic-select>
            </div>
            <div class="w-1/3 flex flex-row items-end gap-3">
              @if (taskForm.get("assignedToUser")!.value != null) {
                <div class="flex flex-row items-center w-full group">
                  @if (taskForm.get('assignedToUser')!.value?.profileImage && !taskForm.get('assignedToUser')!.value?.profileImage?.toLowerCase()?.includes('defaultimages/profile.png')) {
                    <img (error)="taskForm.get('assignedToUser')!.value.profileImage = undefined" alt="Verantwortlicher"
                       class="w-10 h-10 rounded-full"
                         src="{{taskForm.get('assignedToUser')!.value?.profileImage}}">
                } @else {
                  <div
                    class="relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-100 rounded-full">
                    <span
                      class="font-medium text-base text-green">{{ taskForm.get('assignedToUser')!.value?.firstName.charAt(0).toUpperCase() }}{{ taskForm.get('assignedToUser')!.value?.lastName.charAt(0).toUpperCase() }}</span>
                  </div>
                }
                  <div class="flex flex-col gap-1.5 pl-2.5">
                    <span class="text-sm font-medium leading-3">
                      @if (taskForm.get('assignedToUser')!.value.title && taskForm.get('assignedToUser')!.value.title != 'NONE') {
                        <span class="text-sm font-medium leading-3">
                          {{ taskForm.get('assignedToUser')!.value.title | title }}
                        </span>
                      }
                      {{ taskForm.get('assignedToUser')!.value.firstName }} {{ taskForm.get('assignedToUser')!.value.lastName }}</span>
                    <span
                      class="text-sm text-gray-500 leading-3 truncate">{{ $safeNavigationMigration(taskForm.get('assignedToUser')!.value.roleInProjects[taskForm.get('projectID')!.value]?.name) | roleAndPrivileges }}</span>
                  </div>
                  <div (click)="taskForm.get('assignedToUser')!.setValue(null)"
                       class="flex flex-grow items-center justify-end cursor-pointer opacity-0 group-hover:opacity-100">
                    <fa-icon [icon]="faXmark"></fa-icon>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        </form>

        @if (task.comment) {
          <div class="pt-4">
            <span class="block text-sm mb-1 font-medium">Kommentare</span>
            <app-task-comments #comments (saveTask)="saveFromComment($event);" [formGroup]="taskForm"
                               [user]="user" [actionsDisabled]="isSubmitting"></app-task-comments>
          </div>
        }

        @if (!permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {
          <div class="absolute inset-0 z-10 cursor-not-allowed"
               [tooltip]="'Keine Berechtigung'"></div>
        } @else if (isSubmitting) {
          <!-- Klicksperre während des Speicherns: bic-select kennt kein setDisabledState, taskForm.disable()
               erreicht Selects, Datepicker-Auswahl und das × am Verantwortlichen also nicht (#2736). -->
          <div class="absolute inset-0 z-10 cursor-wait" data-testid="task-submitting-overlay"></div>
        }
      </div>

    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
      <bic-button (onClick)="close()" buttonType="white" [disabled]="isSubmitting">Abbrechen</bic-button>
      @if (permissionService.hasProjectPrivilege('PROJECT_TASK_EDIT')) {
        <bic-button (onClick)="save()" [disabled]="taskForm.invalid" [loading]="isSubmitting">Speichern</bic-button>
      } @else {
        <div [tooltip]="'Keine Berechtigung'" class="cursor-not-allowed">
          <bic-button [disabled]="true">Speichern</bic-button>
        </div>
      }
    </div>
  </bic-popup>
}
